import styled from '@xstyled/styled-components';

export const Legend = styled.legend`
  margin: -3px 15px 30px 30px;
  font-family: var(--title-font);
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
`;

export const HeaderBlock = styled.div`
  margin: -3px 15px 30px 30px;
`;
